import React, {useMemo} from "react";
import {useStationQuery, useTimeseriesQuery} from "./query";
import TimeserieHSGraph from "./TimeserieHSGraph";
import TimeserieTempGraph from "./TimeserieTempGraph";

import MDBox from "materialDashboard/components/MDBox";
import {formatISO} from "date-fns";

const TimeseriesGraphs = ({stationId, dateTimeGte, dateTimeLte, station, highlightedDate}) => {
    const range = useMemo(() => {
        const rangeFilter = {};
        if (dateTimeGte) {
            rangeFilter.datetime__gte = formatISO(dateTimeGte);
        }
        if (dateTimeLte) {
            rangeFilter.datetime__lte = formatISO(dateTimeLte);
        }
        return rangeFilter;
    }, [dateTimeGte, dateTimeLte]);

    const timeseriesQuery = useTimeseriesQuery(stationId, range);
    const stationQuery = useStationQuery(stationId, {enabled: !station});
    station = station ?? stationQuery.data;

    const data = useMemo( () => (
        timeseriesQuery.data ?
            timeseriesQuery.data.timestamps.map((timestamp, index) => {
                return {
                    timestamp: new Date(timestamp),
                    hs: timeseriesQuery.data.hs?.[index],
                    hn: timeseriesQuery.data.hn?.[index],
                    ta: timeseriesQuery.data.ta?.[index],
                    th10: timeseriesQuery.data.th10?.[index],
                    th30: timeseriesQuery.data.th30?.[index],
                }
            })
            :
            []
    ), [timeseriesQuery.data])

    return <MDBox sx={{width: "100%", maxWidth: "100%", minWidth: 0, display: "flex", flexDirection: "column", gap: 4 }}>
        <div>
            <TimeserieHSGraph data={data} station={station} highlightedDate={highlightedDate} />
        </div>
        <div>
            <TimeserieTempGraph data={data} station={station} highlightedDate={highlightedDate} />
        </div>
    </MDBox>
}

export default TimeseriesGraphs;
